import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export const PlayerScoreCard = ({ player, isMe = false, buzzed = false, rank, color }) => {
  const { t } = useLang();
  const offline = player.connected === false && !player.isBot;
  return (
  <motion.div
    layout
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    className={`tactile px-4 py-3 flex items-center justify-between gap-3 ${buzzed ? "ring-4 ring-coral" : ""} ${offline ? "opacity-60" : ""}`}
    style={color ? { borderColor: color } : undefined}
    data-testid={`player-score-card-${player.id}`}
  >
    <div className="flex items-center gap-3 min-w-0">
      {rank ? (
        <div className="w-7 h-7 rounded-full bg-navy text-cream font-display font-black flex items-center justify-center text-sm shrink-0">{rank}</div>
      ) : null}
      {color ? (
        <span
          className="w-3 h-3 rounded-full shrink-0 border border-white/70"
          style={{ backgroundColor: color }}
          data-testid={`player-color-dot-${player.id}`}
        />
      ) : null}
      <div className="min-w-0">
        <div className="font-display font-bold text-navy text-lg truncate">{player.name}</div>
        {offline ? (
          <div className="text-xs text-coral font-bold flex items-center gap-1" data-testid={`player-offline-${player.id}`}>
            <span className="w-2 h-2 rounded-full bg-coral animate-pulse inline-block" /> {t("host.offline")}
          </div>
        ) : isMe ? <div className="text-xs text-teal font-bold">YOU</div> : null}
      </div>
    </div>
    <motion.div
      key={player.score}
      initial={{ scale: 1.4, color: "#F59E0B" }}
      animate={{ scale: 1, color: "#1E1B4B" }}
      className="font-display font-black text-2xl"
      data-testid={`player-score-value-${player.id}`}
    >
      {player.score}
    </motion.div>
  </motion.div>
  );
};
